import React from 'react';
import { HealthCardProps } from '../../../types/health-tools';

/**
 * A reusable card component for health tools sections
 * 
 * @param title - The title of the card
 * @param icon - Optional Lucide icon component
 * @param iconColor - Optional color for the icon
 * @param children - Card content
 * @param className - Additional CSS classes
 */
const HealthCard: React.FC<HealthCardProps> = ({
  title,
  icon: Icon,
  iconColor = 'var(--brand-primary)',
  children,
  className = '',
}) => {
  return (
    <div className={`bg-[var(--background-elevated)] rounded-xl shadow-md p-6 border border-[var(--border-subtle)] ${className}`}>
      <h3 className="text-xl font-bold mb-4 text-[var(--text-primary)] flex items-center">
        {Icon && <Icon className="mr-2" style={{ color: iconColor }} />}
        {title}
      </h3>
      {children}
    </div>
  );
};

export default HealthCard; 